export const SporadicBuy = [
  {
    path: "/purchase/sporadicBuy/list",
    name: "purchase-sporadicBuy-list",
    meta: { title: "零星采购" },
    notice: { type: "purchase_apply_sporadic_examine", hasNotice: false },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/sporadicBuy/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/sporadicBuy/create",
    name: "purchase-sporadicBuy-create",
    meta: { title: "新增零星采购", comName: "PurchaseSporadicBuyFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/sporadicBuy/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/sporadicBuy/edit/:id",
    name: "purchase-sporadicBuy-edit",
    meta: { title: "编辑零星采购", comName: "PurchaseSporadicBuyFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/sporadicBuy/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/sporadicBuy/flowPrint/:id",
    name: "purchase-sporadicBuy-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/sporadicBuy/form-print/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/purchase/sporadicBuy/detail/:id",
    name: "purchase-sporadicBuy-detail",
    meta: { title: "零星采购申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "purchase-apply" */ "@/views/purchase/sporadicBuy/form-detail/index.vue"
      ),
  },
];
